// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://arbiscan.io/address/0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb
export const POOL_ADDRESSES_PROVIDER = '0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb';

// IPool https://arbiscan.io/address/0x794a61358D6845594F94dc1DB02A252b5b4814aD
export const POOL = '0x794a61358D6845594F94dc1DB02A252b5b4814aD';

// IPoolConfigurator https://arbiscan.io/address/0x8145eddDf43f50276641b55bd3AD95944510021E
export const POOL_CONFIGURATOR = '0x8145eddDf43f50276641b55bd3AD95944510021E';

// IAaveOracle https://arbiscan.io/address/0xb56c2F0B653B2e0b10C9b928C8580Ac5Df02C7C7
export const ORACLE = '0xb56c2F0B653B2e0b10C9b928C8580Ac5Df02C7C7';

// https://arbiscan.io/address/0x7A9ff54A6eE4a21223036890bB8c4ea2D62c686b
export const PRICE_ORACLE_SENTINEL = '0x7A9ff54A6eE4a21223036890bB8c4ea2D62c686b';

// https://arbiscan.io/address/0xFF1137243698CaA18EE364Cc966CF0e02A4e6327
export const ACL_ADMIN = '0xFF1137243698CaA18EE364Cc966CF0e02A4e6327';

// IACLManager https://arbiscan.io/address/0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B
export const ACL_MANAGER = '0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B';

// IPoolDataProvider https://arbiscan.io/address/0x243Aa95cAC2a25651eda86e80bEe66114413c43b
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x243Aa95cAC2a25651eda86e80bEe66114413c43b';

// https://arbiscan.io/address/0xb76c1a8da369FC39AAdCF39D2446828BcDF6Ee56
export const POOL_IMPL = '0xb76c1a8da369FC39AAdCF39D2446828BcDF6Ee56';

// https://arbiscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://arbiscan.io/address/0x929EC64c34a17401F460460D4B9390518E5B473e
export const DEFAULT_INCENTIVES_CONTROLLER = '0x929EC64c34a17401F460460D4B9390518E5B473e';

// https://arbiscan.io/address/0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73
export const EMISSION_MANAGER = '0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73';

// ICollector https://arbiscan.io/address/0x053D55f9B5AF8694c503EB288a1B7E552f590710
export const COLLECTOR = '0x053D55f9B5AF8694c503EB288a1B7E552f590710';

// https://arbiscan.io/address/0xadcb7e98A462AA2375D03145083eE68A2148F077
export const DEFAULT_A_TOKEN_IMPL = '0xadcb7e98A462AA2375D03145083eE68A2148F077';

// https://arbiscan.io/address/0xC0442C25FE517ac37D6a0D485446307D97d24712
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xC0442C25FE517ac37D6a0D485446307D97d24712';

// https://arbiscan.io/address/0x365d47ceD3D7Eb6a9bdB3814aA23cc06B2D33Ef8
export const RISK_STEWARD = '0x365d47ceD3D7Eb6a9bdB3814aA23cc06B2D33Ef8';

// https://arbiscan.io/address/0x085E34722e04567Df9E6d2c32e82fd74f3342e79
export const EDGE_RISK_STEWARD_CAPS = '0x085E34722e04567Df9E6d2c32e82fd74f3342e79';

// https://arbiscan.io/address/0x35d53dEB2F6f40Ea7af32B6F8BEd88eA966DF1D9
export const EDGE_INJECTOR_CAPS = '0x35d53dEB2F6f40Ea7af32B6F8BEd88eA966DF1D9';

// https://arbiscan.io/address/0x861eeAdB55E41f161F31Acb1BFD4c70E3a964Aed
export const EDGE_RISK_ORACLE = '0x861eeAdB55E41f161F31Acb1BFD4c70E3a964Aed';

// https://arbiscan.io/address/0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4
export const DEBT_SWAP_ADAPTER = '0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4';

// https://arbiscan.io/address/0x9abADECD08572e0eA5aF4d47A9C7984a5AA503dC
export const L2_ENCODER = '0x9abADECD08572e0eA5aF4d47A9C7984a5AA503dC';

// https://arbiscan.io/address/0x771051750e4de7f178370Bae3AaA58f90778c9B9
export const CONFIG_ENGINE = '0x771051750e4de7f178370Bae3AaA58f90778c9B9';

// https://arbiscan.io/address/0x770ef9f4fe897e59daCc474EF11238303F9552b6
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x770ef9f4fe897e59daCc474EF11238303F9552b6';

// https://arbiscan.io/address/0xcC47c4Fe1F7f29ff31A8b62197023aC8553C7896
export const RATES_FACTORY = '0xcC47c4Fe1F7f29ff31A8b62197023aC8553C7896';

// https://arbiscan.io/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const REPAY_WITH_COLLATERAL_ADAPTER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://arbiscan.io/address/0x411D79b8cC43384FDE66CaBf9b6a17180c842511
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x411D79b8cC43384FDE66CaBf9b6a17180c842511';

// https://arbiscan.io/address/0xD61BF98649EA8F8D09e184184777b1867F00E5CB
export const LEGACY_STATIC_A_TOKEN_ORACLE = '0xD61BF98649EA8F8D09e184184777b1867F00E5CB';

// https://arbiscan.io/address/0xF3C3F14dd7BDb7E03e6EBc3bc5Ffc6D66De12251
export const SWAP_COLLATERAL_ADAPTER = '0xF3C3F14dd7BDb7E03e6EBc3bc5Ffc6D66De12251';

// https://arbiscan.io/address/0x68100bD5345eA474D93577127C11F39FF8463e93
export const UI_INCENTIVE_DATA_PROVIDER = '0x68100bD5345eA474D93577127C11F39FF8463e93';

// https://arbiscan.io/address/0x13c833256BD767da2320d727a3691BAff3770E39
export const UI_POOL_DATA_PROVIDER = '0x13c833256BD767da2320d727a3691BAff3770E39';

// https://arbiscan.io/address/0xBc790382B3686abffE4be14A030A96aC6154023a
export const WALLET_BALANCE_PROVIDER = '0xBc790382B3686abffE4be14A030A96aC6154023a';

// https://arbiscan.io/address/0x5283BEcEd7ADF6D003225C13896E536f2D4264FF
export const WETH_GATEWAY = '0x5283BEcEd7ADF6D003225C13896E536f2D4264FF';

// https://arbiscan.io/address/0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9
export const WITHDRAW_SWAP_ADAPTER = '0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9';

// https://arbiscan.io/address/0xd85922fFF51ba4130cEC7c499db4Ac3Eb9981EaD
export const STATA_FACTORY = '0xd85922fFF51ba4130cEC7c499db4Ac3Eb9981EaD';

// https://arbiscan.io/address/0x897c76905A3d17F71d5ea033916B65154Cf4b4f0
export const DUST_BIN = '0x897c76905A3d17F71d5ea033916B65154Cf4b4f0';

// https://arbiscan.io/address/0x7B58055fC6bE4B23cF8c9287b7d3C4adBE919a9c
export const CLINIC_STEWARD = '0x7B58055fC6bE4B23cF8c9287b7d3C4adBE919a9c';

// https://arbiscan.io/address/0xfB1D12D7C9c3Eb6b40fe0502801CdFCE816a0d18
export const POOL_EXPOSURE_STEWARD = '0xfB1D12D7C9c3Eb6b40fe0502801CdFCE816a0d18';

export const CHAIN_ID = 42161;
export const ASSETS = {
  DAI: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    A_TOKEN: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
    V_TOKEN: '0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x9F221bfD2d3F226b187d4419b49117aD7E698977',
    STATIC_A_TOKEN: '0xc91c5297d7E161aCC74b482aAfCc75B85cc0bfeD',
    STATA_TOKEN: '0xf253BD61aEd0E9D62523eA76CD6F38B4a51dA145',
  },
  LINK: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
    A_TOKEN: '0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530',
    V_TOKEN: '0x953A573793604aF8d41F306FEb8274190dB4aE0e',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x86E53CF1B870786351Da77A57575e79CB55812CB',
    STATIC_A_TOKEN: '0x27dE098EF2772386cBCf1a4c8BEb886368b7F9a9',
    STATA_TOKEN: '0xEAB84053B99f2ec4433F5121A1CB1524c8c998F8',
  },
  USDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    A_TOKEN: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
    V_TOKEN: '0xFCCf3cAbbe80101232d343252614b6A3eE81C989',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x6200A5122Af8D5D9e69f4d526311Cd85241ACeC9',
    STATIC_A_TOKEN: '0x0Bc9E52051f553E75550CA22C196bf132c52Cf0B',
    STATA_TOKEN: '0xE6D5923281c89DC989D00817387292387552d5C1',
  },
  WBTC: {
    decimals: 8,
    id: 3,
    UNDERLYING: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    A_TOKEN: '0x078f358208685046a11C85e8ad32895DED33A249',
    V_TOKEN: '0x92b42c66840C7AD907b4BF74879FF3eF7c529473',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x6ce185860a4963106506C203335A2910413708e9',
    STATIC_A_TOKEN: '0x32B95Fbe04e5a51cF99FeeF4e57Cf7e3FC9c5A93',
    STATA_TOKEN: '0x52Dc1FEeFA4f9a99221F93D79da46Ae89b8c0967',
  },
  WETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    A_TOKEN: '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
    V_TOKEN: '0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612',
    STATIC_A_TOKEN: '0x352F3475716261dCC991Bd5F2aF973eB3D0F5878',
    STATA_TOKEN: '0x4cE13a79f45C1Be00BdABD38B764aC28C082704E',
  },
  USDT: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    A_TOKEN: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
    V_TOKEN: '0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x476494a850eec47301F74C8c9c2652495c47C56c',
    STATIC_A_TOKEN: '0xb165a74407fE1e519d6bCbDeC1Ed3202B35a4140',
    STATA_TOKEN: '0xa6D12574eFB239FC1D2099732bd8b5dC6306897F',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xba5DdD1f9d7F570dc94a51479a000E3BCE967196',
    A_TOKEN: '0xf329e36C7bF6E5E86ce2150875a84Ce77f477375',
    V_TOKEN: '0xE80761Ea617F66F96274eA5e8c37f03960ecC679',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xaD1d5344AaDE45F43E596773Bcc4c423EAbdD034',
    STATIC_A_TOKEN: '0x1C0c8EcED17aE093b3C1a1a8fFeBE2E9513a9346',
  },
  EURS: {
    decimals: 2,
    id: 7,
    UNDERLYING: '0xD22a58f79e9481D1a88e00c343885A588b34b68B',
    A_TOKEN: '0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97',
    V_TOKEN: '0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xA14d53bC1F1c0F31B4aA3BD109344E5009051a84',
    STATIC_A_TOKEN: '0x9a40747BE51185A416B181789B671E78a8d045dD',
  },
  wstETH: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x5979D7b546E38E414F7E9822514be443A4800529',
    A_TOKEN: '0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf',
    V_TOKEN: '0x77CA01483f379E58174739308945f044e1a764dc',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x87fE1503beFBF98C35c7526B0c488d950F822C0F',
    STATIC_A_TOKEN: '0x7775d4Ae4Dbb79a624fB96AAcDB8Ca74F671c0DF',
    STATA_TOKEN: '0xe98fc055c99DECD8Da0c111B090885d5d15C774E',
  },
  MAI: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0x3F56e0c36d275367b8C502090EDF38289b3dEa0d',
    A_TOKEN: '0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA',
    V_TOKEN: '0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xAF92b0A685a15F4E26B6d7DA86F1a9C8C01E2a09',
    STATIC_A_TOKEN: '0xB4a0a2692D82301703B27082Cda45B083F68CAcE',
  },
  rETH: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8',
    A_TOKEN: '0x8Eb270e296023E9D92081fdF967dDd7878724424',
    V_TOKEN: '0xCE186F6Cccb0c955445bb9d10C59caE488Fea559',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x256f33FC0110B1297f78f48524631D30B752480D',
    STATIC_A_TOKEN: '0x68235105d6d33A19369D24b746cb7481FB2b34fd',
    STATA_TOKEN: '0xbB8A61425DFE172AA3a6f882aAFaBA00B32b7d59',
  },
  LUSD: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0x93b346b6BC2548dA6A1E7d98E9a421B42541425b',
    A_TOKEN: '0x8ffDf2DE812095b1D19CB146E4c004587C0A0692',
    V_TOKEN: '0xA8669021776Bc142DfcA87c21b4A52595bCbB40a',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xc8b3e2776260c7e7A9C158a2344776e65E10ceE8',
    STATIC_A_TOKEN: '0xDbB6314b5b07E63B7101844c0346309B79f8C20A',
  },
  USDCn: {
    decimals: 6,
    id: 12,
    UNDERLYING: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    A_TOKEN: '0x724dc807b04555b71ed48a6896b6F41593b8C637',
    V_TOKEN: '0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x6200A5122Af8D5D9e69f4d526311Cd85241ACeC9',
    STATIC_A_TOKEN: '0x7CFaDFD5645B50bE87d546f42699d863648251ad',
    STATA_TOKEN: '0x7F6501d3B98eE91f9b9535E4b0ac710Fb0f9e0bc',
  },
  FRAX: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
    A_TOKEN: '0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5',
    V_TOKEN: '0x5D557B07776D12967914379C71a1310e917C7555',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xC1d2Faa98935eA2f2eD34Bc84edb00B387061376',
    STATIC_A_TOKEN: '0x89AEc2023f89E26Dbb7eaa7a98fe3996f9d112A8',
  },
  ARB: {
    decimals: 18,
    id: 14,
    UNDERLYING: '0x912CE59144191C1204E64559FE8253a0e49E6548',
    A_TOKEN: '0x6533afac2E7BCCB20dca161449A13A32D391fb00',
    V_TOKEN: '0x44705f578135cC5d703b4c9c122528C73Eb87145',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xb2A824043730FE05F3DA2efaFa1CBbe83fa548D6',
    STATIC_A_TOKEN: '0x9b5637d7952BC9fa2D693aAE51f3103760Bf2693',
    STATA_TOKEN: '0xf09EDbF2655B2A56753bD60D22CeAB2AC5D04188',
  },
  weETH: {
    decimals: 18,
    id: 15,
    UNDERLYING: '0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe',
    A_TOKEN: '0x8437d7C167dFB82ED4Cb79CD44B7a32A1dd95c77',
    V_TOKEN: '0x3ca5FA07689F266e907439aFd1fBB59c44fe12f6',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x517276B5972C4Db7E88B9F76Ee500E888a2D73C3',
    STATA_TOKEN: '0xD9E3Ef2c12de90E3b03F7b7E3964956a71920d40',
  },
  GHO: {
    decimals: 18,
    id: 16,
    UNDERLYING: '0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33',
    A_TOKEN: '0xeBe517846d0F36eCEd99C735cbF6131e1fEB775D',
    V_TOKEN: '0x18248226C16BF76c032817854E7C83a2113B4f06',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xB05984aD83C20b3ADE7bf97a9a0Cb539DDE28DBb',
    STATIC_A_TOKEN: '0xD9FBA68D89178e3538e708939332c79efC540179',
    STATA_TOKEN: '0xD089B4cb88Dacf4e27be869A00e9f7e2E3C18193',
  },
  ezETH: {
    decimals: 18,
    id: 17,
    UNDERLYING: '0x2416092f143378750bb29b79eD961ab195CcEea5',
    A_TOKEN: '0xEA1132120ddcDDA2F119e99Fa7A27a0d036F7Ac9',
    V_TOKEN: '0x1fFD28689DA7d0148ff0fCB669e9f9f0Fc13a219',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x8Ed37B72300683c0482A595bfa80fFb793874b15',
    STATA_TOKEN: '0x4ff50C17df0D1b788d021ACd85039810a1aA68A1',
  },
  rsETH: {
    decimals: 18,
    id: 18,
    UNDERLYING: '0x4186BFC76E2E237523CBC30FD220FE055156b41F',
    A_TOKEN: '0x6b030Ff3FB9956B1B69f475B77aE0d3Cf2CC5aFa',
    V_TOKEN: '0x80cA0d8C38d2e2BcbaB66aA1648Bd1C7160500FE',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0xb4B0cbcA864c2Eb0C0342608D92490C034aC1089',
  },
  tBTC: {
    decimals: 18,
    id: 19,
    UNDERLYING: '0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40',
    A_TOKEN: '0x62fC96b27a510cF4977B59FF952Dc32378Cc221d',
    V_TOKEN: '0xB5b46F918C2923fC7f26DB76e8a6A6e9C4347Cf9',
    INTEREST_RATE_STRATEGY: '0x429F16dBA3B9e1900087Cbaa7b50D38Bc60fB73F',
    ORACLE: '0x6ce185860a4963106506C203335A2910413708e9',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'DAI,USDC,USDT,EURS,USDCn / ',
    collateralBitmap: '4261',
    collateralAssets: [
      '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
      '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      '0xD22a58f79e9481D1a88e00c343885A588b34b68B',
      '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    ],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '129',
    ltvzeroAssets: [
      '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      '0xD22a58f79e9481D1a88e00c343885A588b34b68B',
    ],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'WETH,wstETH,weETH / WETH',
    collateralBitmap: '33040',
    collateralAssets: [
      '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      '0x5979D7b546E38E414F7E9822514be443A4800529',
      '0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe',
    ],
    borrowableBitmap: '16',
    borrowableAssets: ['0x82aF49447D8a07e3bd95BD0d56f35241523fBab1'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '3': {
    label: 'ezETH / WETH,wstETH',
    collateralBitmap: '131072',
    collateralAssets: ['0x2416092f143378750bb29b79eD961ab195CcEea5'],
    borrowableBitmap: '272',
    borrowableAssets: [
      '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      '0x5979D7b546E38E414F7E9822514be443A4800529',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '4': {
    label: 'ezETH / USDT,USDCn',
    collateralBitmap: '131072',
    collateralAssets: ['0x2416092f143378750bb29b79eD961ab195CcEea5'],
    borrowableBitmap: '4128',
    borrowableAssets: [
      '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '5': {
    label: 'rsETH / WETH,wstETH',
    collateralBitmap: '262144',
    collateralAssets: ['0x4186BFC76E2E237523CBC30FD220FE055156b41F'],
    borrowableBitmap: '272',
    borrowableAssets: [
      '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      '0x5979D7b546E38E414F7E9822514be443A4800529',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '6': {
    label: 'rsETH / USDC,USDT',
    collateralBitmap: '262144',
    collateralAssets: ['0x4186BFC76E2E237523CBC30FD220FE055156b41F'],
    borrowableBitmap: '36',
    borrowableAssets: [
      '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
      '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '7': {
    label: 'wstETH / WETH',
    collateralBitmap: '256',
    collateralAssets: ['0x5979D7b546E38E414F7E9822514be443A4800529'],
    borrowableBitmap: '16',
    borrowableAssets: ['0x82aF49447D8a07e3bd95BD0d56f35241523fBab1'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
